import { render } from "./Shop.vue?vue&type=template&id=232c77a4&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=232c77a4&lang=scss&scoped=true"
import "./Shop.vue?vue&type=style&index=1&id=232c77a4&lang=css"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232c77a4"]])

export default __exports__